class TitleRevenueChart {
  static CHART_SELECTOR = '#title-revenue-piechart';

  constructor () {
    this.data = window.sflow.data.titleRevenue || { series: [], labels: [] };
    this.sanitizeData();
    this.initChart();
  }

  sanitizeData () {
    // Ensure all series data are valid numbers
    if (this.data.series && this.data.series.length > 0) {
      this.data.series = this.data.series.map(value => {
        // Convert to number if it's a string number
        const num = parseFloat(value);
        // Return 0 if it's NaN or null/undefined
        return isNaN(num) ? 0 : num;
      });

      // Check if we have at least one non-zero value
      const hasNonZeroValues = this.data.series.some(value => value > 0);
      if (!hasNonZeroValues) {
        // If all values are zero or invalid, add a dummy value to prevent chart errors
        this.data.series = [1];
        this.data.labels = ['No Revenue Data'];
      }
    }
  }

  initChart () {
    const chartElement = document.querySelector(TitleRevenueChart.CHART_SELECTOR);

    if (!chartElement || !this.data.series || this.data.series.length === 0) {
      console.log('Chart element or data missing', this.data);
      return;
    }

    const options = {
      series: this.data.series,
      colors: window.sflow.data.chartColors,
      chart: {
        type: 'donut',
        redrawOnParentResize: true,
      },
      labels: this.data.labels,
      plotOptions: {
        pie: {
          donut: {
            size: '50%',
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function(val, opts) {
          if (!opts.w.globals.series || !opts.w.globals.series[opts.seriesIndex]) {
            return 'Unknown';
          }
          const title = opts.w.globals.seriesNames[opts.seriesIndex];
          const words = title.trim().split(/\s+/);

          // If there's only one word or its short enough, return it
          if (title.length <= 5) {
            return title;
          }
          if (words.length === 1) {
            return words[0];
          }

          // Otherwise, create an acronym from the first letter of each word
          return words.map(word => word.charAt(0).toUpperCase()).join('').substr(0, 5);
        },
      },
      tooltip: {
        y: {
          formatter: function(value) {
            if (typeof value === 'number' && !isNaN(value)) {
              return '$' + value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            return '$0.00';
          },
        },
      },
      legend: {
        position: 'bottom',
        formatter: function(seriesName, opts) {
          if (!opts.w.globals.series || !opts.w.globals.series[opts.seriesIndex]) {
            return [seriesName, ' - ', '$0.00'];
          }
          const value = opts.w.globals.series[opts.seriesIndex];
          var money = typeof value === 'number' && !isNaN(value) ?
            '$' + value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') :
            '$0.00';
          return [seriesName, ' - ', money];
        },
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            height: 300,
          },
          legend: {
            position: 'bottom',
          },
        },
      }],
    };

    const chart = new ApexCharts(chartElement, options);
    chart.render();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector(TitleRevenueChart.CHART_SELECTOR) !== null) {
    window.sflow.titleRevenueChart = new TitleRevenueChart();
  }
});